var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShortlistedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#ECFDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.253 21h10.692A5.062 5.062 0 0 1 39 26.063v14.062a4.5 4.5 0 0 0 4.5-4.5V21.162c0-2.258-1.687-4.217-3.996-4.409a72.954 72.954 0 0 0-1.01-.076A4.5 4.5 0 0 0 34.5 14.25h-2.25a4.5 4.5 0 0 0-3.995 2.427c-.337.023-.673.048-1.01.076-2.253.187-3.914 2.058-3.992 4.247zm8.997-4.5A2.25 2.25 0 0 0 30 18.75h6.75a2.25 2.25 0 0 0-2.25-2.25h-2.25z",
    fill: "#027A48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 26.063a2.813 2.813 0 0 1 2.813-2.813h14.625a2.813 2.813 0 0 1 2.812 2.813v16.875a2.813 2.813 0 0 1-2.813 2.812H19.313a2.813 2.813 0 0 1-2.813-2.813V26.064zm14.378 6.89a1.125 1.125 0 0 0-1.756-1.406l-3.715 4.644-1.361-1.361a1.125 1.125 0 0 0-1.591 1.59l2.25 2.25a1.125 1.125 0 0 0 1.674-.092l4.5-5.625z",
    fill: "#027A48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortlistedIcon);
export default __webpack_public_path__ + "static/media/shortlisted-icon.28bd7ffca62ac9ebd8298823d993f953.svg";
export { ForwardRef as ReactComponent };